import React from 'react';
import { Paper, Box, Tabs, Tab } from '@mui/material';
import TechReqFormContainer from './TechReqFormContainer';
import TechFileListContainer from '../techmng/support/TechFileListContainer';
import TechReqView from '../../components/techmng/support/TechReqView';
import TabPanel from '../../components/common/tabs/TabPanel';


function a11yProps(index) {
    return {
        id: `tech-tab-${index}`,
        'aria-controls': `tech-tabpanel-${index}`,
    };
}

const TechFirstStepContainer = ({ activeTap, handleTabChange, tech, project, user }) => {
    return (
        <Paper
            sx={{
                mt: 1,
                pb: 1,
            }}
        >
            <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={activeTap}
                    onChange={handleTabChange}
                    aria-label="기술 지원 관리"
                >
                    <Tab label="지원요청" {...a11yProps(0)} />
                    <Tab label="파일 리스트" {...a11yProps(1)} />
                </Tabs>
            </Box>
            <TabPanel value={activeTap} index={0}>
                {(user.usrUuid === tech?.crtUsr && Number(tech.reqGrade) < 4) ? (
                    <TechReqFormContainer project={project} tech={tech} user={user} />
                ) : (<TechReqView project={project} tech={tech} />)}

            </TabPanel>
            <TabPanel value={activeTap} index={1}>
                <TechFileListContainer tech={tech} />
            </TabPanel>
            <Box sx={{ width: '100%', borderTop: 1, borderColor: 'divider' }}>
                <Tabs
                    value={activeTap}
                    onChange={handleTabChange}
                    aria-label="기술 지원 관리"
                    TabIndicatorProps={{ style: { top: 0 } }}
                >
                    <Tab label="지원요청" {...a11yProps(0)} />
                    <Tab label="파일 리스트" {...a11yProps(1)} />
                </Tabs>
            </Box>

        </Paper>
    );
};

export default TechFirstStepContainer;
